import { createSelectorPathBuilder } from '@/checkout-instore-legacy/utils/selectorHelper'

export const appStateSelector = createSelectorPathBuilder([
  (state: any): string => state?.device?.appState,
])
